import type { Placement } from '@popperjs/core';
import { IconName, useCallbackRef, useDropdownPopper, type DropdownProps, type PopperHeaderProps } from '@talos/kyoko';
import { useMemo, type RefObject } from 'react';

interface UseRFQSweepingPanelParams {
  isOpen: boolean;
  close: () => void;
  panelAnchorRef: RefObject<HTMLElement>;
  panelOffset?: number;
  panelPlacement?: Placement;
}

export function useRFQSweepingPanel({
  isOpen,
  close,
  panelAnchorRef,
  panelOffset = 0,
  panelPlacement = 'top-end',
}: UseRFQSweepingPanelParams): Omit<DropdownProps, 'children'> {
  const closePanel = useCallbackRef(() => {
    close();
  });

  const dropdown = useDropdownPopper({
    isOpen,
    offset: panelOffset,
    padding: 8,
    referenceElement: panelAnchorRef.current,
    dropdownPlacement: panelPlacement,
    dropdownWidth: '750px',
    dropdownHeight: '560px', // 560 fits all the internals nicely
    onClickOutside: closePanel,
    tetherToRefElement: false,
  });

  const headerProps: PopperHeaderProps = useMemo(
    () => ({
      title: 'Sweeping',
      icon: IconName.Scale,
      onCloseClicked: closePanel,
    }),
    [closePanel]
  );

  return useMemo(
    () => ({
      ...dropdown,
      headerProps,
    }),
    [dropdown, headerProps]
  );
}
